import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { VolunteerFormState } from '../types';
import { FormPanel, FormSectionTitle, SectionTitle, ValidationText } from '../styles';
import { Text } from '@/components/UI/Typography/Text';
import { Box } from '@/layout/Box';
import { theme } from '@/theme/Theme';

interface Props {
  form: VolunteerFormState;
  errors: FieldErrors<VolunteerFormState>;
  control: Control<VolunteerFormState>;
  isTablet: boolean;
}

const PostCompletionStep = ({ errors, control, isTablet }: Props) => {
  //   @ts-ignore
  const { t } = useTranslation();

  return (
    <FormPanel isTablet={isTablet}>
      <SectionTitle>{t('pbl.lawyerRegistration.postCompletion.section', { defaultValue: 'Section 7' })}</SectionTitle>
      <FormSectionTitle>
        {t('pbl.lawyerRegistration.steps.postCompletion', {
          defaultValue: 'Post Completion of Pro Bono Service',
        })}
      </FormSectionTitle>

      <Box marginBottom={30}>
        <Text fontSize={theme.fontSizes.base}>
          {t('pbl.lawyerRegistration.postCompletion.paragraph15', {
            defaultValue:
              '15. Upon completion of a pro bono case under the Scheme, the handling volunteer lawyer is required to notify the Scheme of the completion of the pro bono service and to provide feedback on the operation of the Scheme by completing and submitting a prescribed notification and evaluation form to the Scheme.',
          })}
        </Text>
      </Box>
      <br />
      <Box marginBottom={30}>
        <Text fontSize={theme.fontSizes.base}>
          {t('pbl.lawyerRegistration.postCompletion.paragraph16', {
            defaultValue:
              "16. Should the handling volunteer lawyer be invited to continue the advisory service after the pro bono service limit of 45 minutes has been exhausted, he or she is required to continue to offer legal service to the enquirer at a discounted rate of no less than 20% on the lawyer's existing standard charge-out rate and to use the DMP as the main communication channel.",
          })}
        </Text>
      </Box>

      <Box padding={'10px 0 0 0'}>
        <FormGroup>
          <Controller
            control={control}
            name="post_completion_agreed"
            rules={{
              validate: (value) =>
                value ||
                t('pbl.lawyerRegistration.postCompletion.errors.agreementRequired', {
                  defaultValue: 'You must agree to continue.',
                }),
            }}
            render={({ field }) => (
              <FormControlLabel
                control={
                  <Checkbox checked={!!field.value} onChange={(event) => field.onChange(event.target.checked)} />
                }
                label={t('pbl.lawyerRegistration.postCompletion.agreement', {
                  defaultValue:
                    'I confirm my agreement to the submission of a completed notification and evaluation form and to the offer of service at a discounted rate and the use of the DMP for non pro bono service as set out in paragraphs 15 and 16 above.',
                })}
              />
            )}
          />
        </FormGroup>
        {errors.post_completion_agreed?.message && (
          <ValidationText>{errors.post_completion_agreed.message}</ValidationText>
        )}
      </Box>
    </FormPanel>
  );
};

export default PostCompletionStep;
